/* eslint-disable jira/naming/disallow-filenames */

import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import type { PreconditionResult } from './PreconditionResult.types.tsx';

export const devOpsReportPreconditionResource: RouteResource<PreconditionResult> =
	createResource<PreconditionResult>({
		type: 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION',
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-devops-report-precondition", jiraSpaEntry: "async-resource-devops-report-precondition" */ './getData.tsx'
			),
		maxAge: 60 * 1000,
	});

export const useDevOpsReportPreconditionResource =
	(): UseResourceHookResponse<PreconditionResult> =>
		useResource<PreconditionResult>(devOpsReportPreconditionResource);
